"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIDsAndLabels = void 0;
var utils_1 = require("@time-input-polyfill/utils");
var getIDsAndLabels = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.primaryTestsLabel, primaryTestsLabel = _c === void 0 ? 'Primary tests' : _c, _d = _b.eventTestsLabel, eventTestsLabel = _d === void 0 ? 'Event tests' : _d;
    var labels = { primaryTestsLabel: primaryTestsLabel, eventTestsLabel: eventTestsLabel };
    var primaryInputID = primaryTestsLabel.toLowerCase().replaceAll(' ', '-');
    var eventsInputID = eventTestsLabel.toLowerCase().replaceAll(' ', '-');
    var IDs = {
        primaryInputID: primaryInputID,
        primaryValueID: "".concat(primaryInputID, "-primary-value"),
        buttonIDs: {
            amID: "".concat(primaryInputID, "-am-button"),
            pmID: "".concat(primaryInputID, "-pm-button"),
            blankID: "".concat(primaryInputID, "-blank-button"),
            togglePolyfillID: "".concat(primaryInputID, "-toggle-polyfill-button"),
        },
        eventsInputID: eventsInputID,
        eventsValueID: "".concat(eventsInputID, "-event-value"),
        eventsMainNameID: "".concat(eventsInputID, "-main-event-name"),
        eventsAltNameID: "".concat(eventsInputID, "-alt-event-name"),
        a11yID: utils_1.a11yID,
    };
    return { labels: labels, IDs: IDs };
};
exports.getIDsAndLabels = getIDsAndLabels;
